<template>
  <v-flex md4 sm6 xs12>

    <v-layout row >
      <v-flex xs6 class="" style="">
        <a data-pin-do="embedPin" :href="item.pin"></a>
      </v-flex>
      <v-flex column xs6 class="text-xs-left ml-2" >
        <div class="subheading text-xs-left">
          {{ item.title }}
        </div>
        <br />
        Materials:<br />

          <MaterialLine v-for="mitem in this.item.materials" :item="mitem"></MaterialLine>
          <hr />
          <v-layout row>
            <v-flex>Total:</v-flex>
            <v-spacer></v-spacer>
            <v-flex xs2>{{ totalCogFormatted }}</v-flex>
          </v-layout>
          <br />
          <v-layout row>
            <v-flex xs12>Estimated sale price:</v-flex>
            <v-flex xs4>{{ priceEstimate }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>Cost of Goods (CoG):</v-flex>
            <v-flex xs4>{{ cog }}</v-flex>
          </v-layout>
          <hr />
          <v-layout row>
            <v-flex xs12>Profit:</v-flex>
            <v-flex xs4>{{ profit }}</v-flex>
          </v-layout>

          <br />
          Time to complete: {{time}}<br />
          Ages: {{ age }}<br />
        </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import utils from '../../../utils.ts'

import MaterialLine from './MaterialLine.vue'

export default {
  components: {
    MaterialLine
  },
  props: ['item'],
  data () {
    return {
      // item: {
      //   title: 'Custom champagne glasses',
      //   materials: [
      //     ['glasses', 10, 'mylink'],
      //     ['paint', 2, 'mylink'],
      //     ['tape', 2, 'yourlink'],
      //   ],
      //   time: '1 hour',
      //   age: 8,
      //   priceEstimate: 15,
      // materialsMake: 50, // How many the materials make

      //   pin: "https://www.pinterest.com/pin/572027590169584389/"
      // }
    }
  },
  computed: {
    ...mapState({

    }),
    time () {
      return this.item.time
    },
    priceEstimate () {
      return utils.formatCurrency(this.item.priceEstimate)
    },
    totalCog () {
      let totalCost = 0
      for (let i in this.item.materials) {
        totalCost += this.item.materials[i].cost
      }

      return totalCost
    },
    totalCogFormatted () {
      return utils.formatCurrency(this.totalCog)
    },
    totalCost () {
      return this.totalCog / this.item.materialsMake
    },
    profit () {
      return utils.formatCurrency(this.item.priceEstimate - this.totalCost)
    },
    cog () {
      return utils.formatCurrency(this.totalCost)
    },
    age () {
      return this.item.age + " and up"
    }
  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

.linktext {
  color: white;
}

</style>
